<script>
import Mixin from "@/components/Relatorios/Mixin";
import $axios from "@/api/api";

export default {
  name: "Exemplo",
  mixins: [Mixin],
  mounted() {
    this.gerarRelatorio();
  },
  watch: {
    DIALOG_ATIVO(valor) {
      if (valor) this.gerarRelatorio();
    }
  },
  methods: {
    gerarRelatorio() {
      this.DIALOG_ATIVO = false;
      const url = `${this.relatorio.url}`;
      window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");
    }
  }
}
</script>

<template>
  <div></div>
</template>
